export const SET_DATA = 'PAPERS_SET_DATA';
export const LOAD = 'PAPERS_LOAD';
export const SET_ERRORS = 'PAPERS_SET_ERRORS';

export function setData(data, elementId) {
    return {
        type: SET_DATA,
        elementId,
        payload: data,
    };
}

export function load(data, elementId) {
    return {
        type: LOAD,
        elementId,
        payload: data,
    };
}

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        errors,
    };
};
